import * as React from 'react';

import { SvgVirtualConnectionTable } from '../../../../gen-src/icons/VirtualConnectionTable';
import { SvgVirtualConnectionTableExtract } from '../../../../gen-src/icons/VirtualConnectionTableExtract';

export function VirtualConnectionTableTypeIcon(props: { isExtracted: boolean }): JSX.Element {
  if (props.isExtracted) {
    return <SvgVirtualConnectionTableExtract />;
  } else {
    return <SvgVirtualConnectionTable />;
  }
}
